
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study-abroad",
      function () {
        return require("private-next-pages/study-abroad/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/study-abroad"])
      });
    }
  